import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject, Observable } from 'rxjs';
import {  DataSourceLoadOptions, MachineOwner, OwnersService } from 'src/api/generated';
import { MessagesService } from './messages.service';


@Injectable({
  providedIn: 'root'
})
export class MachineOwnerService {
  public loadingOwr: boolean = true;
  private _owrSrc: BehaviorSubject<MachineOwner | undefined> = new BehaviorSubject<MachineOwner | undefined>(undefined);
  public owrSrc$: Observable<MachineOwner | undefined> = this._owrSrc.asObservable();
  private _ownersCache: BehaviorSubject<MachineOwner[]> = new BehaviorSubject<MachineOwner[]>([]);
  public ownersCache$: Observable<MachineOwner[]> = this._ownersCache.asObservable();

  private _ownersDataSource: DataSource<MachineOwner, string>;

  constructor(
    private readonly _ownersSvc: OwnersService,
    private readonly _msgSvc: MessagesService,
  ) {
    this._ownersDataSource = new DataSource<MachineOwner, string>({
      key: 'Id',
      load: (loadOptions) => {
        return this._ownersSvc.filterPost(loadOptions as DataSourceLoadOptions).toPromise();
      },
      byKey: function (key) {
        return Promise.resolve({});
      }
    });

    this._refreshOwnersCache();
  }

  public set CurrentRow(r: MachineOwner | undefined) {
    this._owrSrc.next(r);
  }

  public get CurrentRow(): MachineOwner | undefined {
    return this._owrSrc.value;
  }

  public get ListDataSource(): DataSource<MachineOwner, string> {
    return this._ownersDataSource;
  }

  public getOwnerNameById(value: string): string {
    const o = this._ownersCache.value.find(o => o.Id == value);

    if (o != undefined) {
      return o.Name ?? '';
    }

    return value;
  }

  public get AllOwners(): MachineOwner[]{
    return this._ownersCache.value;
  }

  public _refreshOwnersCache() {
    this._ownersSvc.filterPost({}).subscribe({
        next: (res: any) => {
          this._ownersCache.next(res.data ?? []);
        },
        error: e => {
          this._msgSvc.ShowError(e);
        }
      });
  }
}
